export default __webpack_public_path__ + "static/thesis-fb08be4997b953eea4294b4ecd3cacb9.pdf";